import { render, staticRenderFns } from "./placeLink.vue?vue&type=template&id=44822d8c&"
import script from "./placeLink.vue?vue&type=script&lang=js&"
export * from "./placeLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports